import { render, staticRenderFns } from "./ModalEditOptionSortOrder.vue?vue&type=template&id=046dc21c"
import script from "./ModalEditOptionSortOrder.vue?vue&type=script&lang=js"
export * from "./ModalEditOptionSortOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports